angular
  .module("accordionFatturazioneElettronica.components", [])
  .component("accordionFatturazioneElettronica", {
    templateUrl: "ng/components/accordionFatturazioneElettronica/accordionFatturazioneElettronica.view.html",
    bindings: {
      sedeFatturazione: "<",
      fatturazione: "<",
      onFatturazioneOk: "&",
      onFatturazioneKo: "&",
      isFinancial: "=",
      disabledInput: "<",
      viewIndex: "=",
      snapshot: "<",
      mode: "<",
      updateFattFromArc: "&",
      initialTabIndex: "=",
      id: "<",
      isVolturante: "<",
      isRichiestaVoltura: "=",
      model: "<",
      isExpansed: "<"
    },
    controllerAs: "fatturazioneElettronicaCtrl",
    controller: function accordionFatturazioneElettronica(
      validationService,
      $portalService,
      $scope,
      $rootScope
    ) {
      var self = this;
      self.fromInstant = true;

      self.$onInit = function () {
        self.model = {};

        self.supportModel = {
          initialIndex: 1
        }

        self.supportModel.initialIndex = self.initialTabIndex || 1;

        if (
          ($portalService.isAra() && self.viewIndex == 2 && !self.snapshot) ||
          self.mode === "NUARC"
        ) {
          $("#fattElectr").removeClass("show");
          $(".icon-freccia-su").addClass("collapsed");
        }

        if (self.mode != "NUARC") {
          self.model = self.sedeFatturazione.fatturazione;
          if (
            !self.model.cdDestinatarioFatturazione &&
            !self.model.emailFatturazioneElettronica
          ) {
            self.disabledInput = true;
          }
        }

        if ($portalService.isAru()) {
          if (self.mode === "NUARC") {
            if (self.fatturazione && !!self.fatturazione.cdDestinatarioFatturazione ||
              !!self.fatturazione.emailFatturazioneElettronica) {
              self.model = self.fatturazione;
              self.disabledInput = false;
              if (self.id === "CESS" || self.id === "VOL") {
                self.disabledInput = true;
                self.validate();
              }
            } else {
              self.disabledInput = true;
            }
          } else if (!self.isFinancial) {
            if (!!self.model.cdDestinatarioFatturazione ||
              !!self.model.emailFatturazioneElettronica) {
              self.disabledInput = true;
            }
          }
          self.validateFattElettronica();
        } else {
          self.validate();
        }

        if (self.isFinancial) {
          self.fromInstant = false;
        }

        if (typeof self.disabledInput == "undefined") {
          self.disabledInput = true;
        }

        //visualizza disclaimer
        self.isM12 = getWizardMap(self.viewIndex) == "M12" ? true : false;
      };

      self.$onChanges = function (changes) {
        console.log('accordionFatturazioneElettronica', changes);
        if (self.fatturazione !== undefined) {
          if (self.fatturazione.cdDestinatarioFatturazione && self.model) {
            self.model.cdDestinatarioFatturazione = self.fatturazione.cdDestinatarioFatturazione;
          }
          if (self.fatturazione.emailFatturazioneElettronica && self.model) {
            self.model.emailFatturazioneElettronica = self.fatturazione.emailFatturazioneElettronica;
          }
          if (self.fatturazione.riferimentoAmministrativo && self.model) {
            self.model.riferimentoAmministrativo = self.fatturazione.riferimentoAmministrativo;
          }
        }
      }

      self.validate = function (value, name) {
        if (self.id === "CESS" && !self.disabledInput) {
          self.validateFattElettronica();
        } else {
          if (name == "cdDestinatarioFatturazione" && value !== undefined) {
            self.model.cdDestinatarioFatturazione = value;
          } else if (name == "emailFatturazioneElettronica") {
            self.model.emailFatturazioneElettronica = value;
          } else if (
            name == "riferimentoAmministrativo" &&
            typeof value != undefined &&
            value != null
          ) {
            self.model.riferimentoAmministrativo = value.substring(0, 20);
          }
          self.validateFattElettronica();
        }
      };

      self.validateFattElettronica = function () {
        self.testPresenzaCampi = validationService.isValidCdDestinatario(self.model.cdDestinatarioFatturazione) ||
          validationService.isValidEmail(self.model.emailFatturazioneElettronica)

        if (
          validationService.isValidCdDestinatario(
            self.model.cdDestinatarioFatturazione
          ) ||
          validationService.isValidEmail(
            self.model.emailFatturazioneElettronica
          )
        ) {
          self.onFatturazioneOk({
            fatturazioneElettronica: self.model,
          });
        } else {
          self.onFatturazioneKo({
            fatturazioneElettronica: self.model,
          });
        }
      }

      self.updateFattData = function () {
        self.updateFattFromArc();
      };

      $scope.$on("collapseFatt", function () {
        $("#fattElectr").removeClass("collapse");
        $("#fattElectr").removeClass("show");
        $("#fattElectr").addClass("collapsing");
        $("#fattElectr").removeClass("collapsing");
        $("#fattElectr").addClass("collapse");
        $("#fattElectr").addClass("collapse");
        $(".icon-freccia-su").addClass("collapsed");
      });

      var getWizardMap = function (viewIndex) {
        if ($rootScope.wizardMap && viewIndex) {
          var view = $rootScope.wizardMap.find(function (element) {
            return element.index == viewIndex;
          })

          return view && view.viewName;
        }
      }

      self.closeOtherAccordion = function () {
        var allAccordion = ["#collapseZero", "#collapseOne", "#collapseTwo", "#collapseThree", "#collapseFive", "#collapseSix", "#collapseSeven", "#collapseEight"];
        if (!$portalService.isAru() && self.mode != "NUARC") {
          return;
        }

        allAccordion.forEach(iesimo => {
          jQuery(iesimo).collapse("hide");
        })

      }
    }
  });